// src/pages/TestCategoryEdit.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Dropzone from "react-dropzone";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

export default function TestCategoryEdit() {
  const { id: testId, categoryId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ name: "", image: null });
  const [preview, setPreview]     = useState(null);
  const [loading, setLoading]     = useState(false);

  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (key, def) => translations[key] || def;

  // Mevcut kategoriyi çek
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
            const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/test-categories/category/${categoryId}`,
            { headers: { Authorization: `Bearer ${token}` } }
            );
        setFormData({ name: data.name, image: null });
        setPreview(
          data.image_url
            ? `${process.env.REACT_APP_API_BASE_URL}${data.image_url}`
            : null
        );
      } catch (err) {
        console.error(err);
        toast.error(t("CATEGORY_FETCH_ERROR", "Kategori verisi alınamadı"));
      }
    })();
  }, [testId, categoryId]);

  // Görsel seçme
  const onDrop = files => {
    if (!files.length) return;
    const file = files[0];
    setFormData(p => ({ ...p, image: file }));
    setPreview(URL.createObjectURL(file));
  };
  const removeImage = () => {
    setFormData(p => ({ ...p, image: null }));
    setPreview(null);
  };

  // İsim alanı
  const handleChange = e =>
    setFormData(p => ({ ...p, [e.target.name]: e.target.value }));

  // Gönder
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("admin_token");
      const fd = new FormData();
      fd.append("name", formData.name);
      if (formData.image) {
        fd.append("image", formData.image);
      } else if (!preview) {
        // Eğer önceki varsa ve kullanıcı kaldırdıysa:
        fd.append("imageRemoved", true);
      }
            await axios.put(
            `${process.env.REACT_APP_API_BASE_URL}/api/test-categories/category/${categoryId}`,
            fd,
            { headers: { Authorization: `Bearer ${token}` } }
            );
                        toast.success("Kayıt güncellendi!");
                        setTimeout(() => {
                          navigate(`/test/${testId}/category/list`);
                        }, 1000);
    
    } catch (err) {
      console.error(err);
      toast.error(t("CATEGORY_UPDATE_ERROR", "Güncelleme başarısız"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-4">
      <ToastContainer />
      <div className="card p-4 shadow-sm">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">{t("CATEGORY_NAME", "Kategori Adı")}</label>
            <input
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              disabled={loading}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label">
              {t("CATEGORY_IMAGE_OPTIONAL", "Resim (opsiyonel)")}
            </label>
            <Dropzone onDrop={onDrop} accept={{ "image/*": [] }} multiple={false}>
              {({ getRootProps, getInputProps }) => (
                <div
                  {...getRootProps()}
                  className="border p-3 text-center"
                  style={{ cursor: "pointer", borderStyle: "dashed" }}
                >
                  <input {...getInputProps()} />
                  {preview ? (
                    <>
                      <img
                        src={preview}
                        alt=""
                        width={100}
                        className="mb-2"
                      />
                      {formData.image && <div>{formData.image.name}</div>}
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={removeImage}
                      >
                        {t("REMOVE_IMAGE", "Resmi Kaldır")}
                      </button>
                    </>
                  ) : (
                    <p>{t("DROP_IMAGE", "Buraya resim sürükleyin veya tıklayın")}</p>
                  )}
                </div>
              )}
            </Dropzone>
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? t("SAVING", "Kaydediliyor...") : t("SAVE", "Kaydet")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
